// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore/lite";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDlZIWrQKYu20IA_rVNmickaBCZQShYXX8",
  authDomain: "advancaresubscriptionsdk.firebaseapp.com",
  projectId: "advancaresubscriptionsdk",
  storageBucket: "advancaresubscriptionsdk.firebasestorage.app",
  messagingSenderId: "616168015923",
  appId: "1:616168015923:web:3d4fa4d7942ffad068bb46",
  measurementId: "G-7S0Z6Y7JC7",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
export { db };
export default firebaseConfig;
